// 基准大小
const baseSize = 30
// 设置 rem 函数
function setRem() {
  // 防止微信浏览器字体大小设置影响
  document.documentElement.style.webkitTextSizeAdjust = '100%'
  document.documentElement.style.msTextSizeAdjust = '100%'
  document.documentElement.style.textSizeAdjust = '100%'
  
  // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 750
  // 设置页面根节点字体大小，强制覆盖微信设置
  const fontSize = baseSize * Math.min(scale, 2) + 'px'
  document.documentElement.style.fontSize = fontSize + ' !important'
  
  // 额外防护：确保body也不受影响
  document.body.style.webkitTextSizeAdjust = '100%'
  document.body.style.msTextSizeAdjust = '100%'
  document.body.style.textSizeAdjust = '100%'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function() {
  setRem()
}

// 监听微信字体大小变化事件（如果有的话）
document.addEventListener('DOMContentLoaded', function() {
  setRem()
})

// 页面加载完成后再次确保设置正确
window.addEventListener('load', function() {
  setRem()
})